const PlansIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2"
      y="16"
      width="19.7992"
      height="19.7992"
      rx="2"
      transform="rotate(-45 2 16)"
      stroke="#3D3A62"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23 16L16 23" stroke="#3D3A62" strokeWidth="2" strokeLinecap="round" />
    <path d="M17 16L13 20" stroke="#3D3A62" strokeWidth="2" strokeLinecap="round" />
    <path d="M11 16L10 17" stroke="#3D3A62" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default PlansIcon;
